// scroll animate js
document.addEventListener('DOMContentLoaded', function () {
  const scrollTriggers = document.querySelectorAll('.scroll-trigger');
  if (!scrollTriggers.length) return;
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    }
  );
  scrollTriggers.forEach(function (element) {
    observer.observe(element);
  });
});


(function () {
  function init(root) {
    root = root || document;

    // -----------------------------
    // Reveal animation
    // -----------------------------
    const revealEls = root.querySelectorAll('.st-reveal:not([data-st-init])');

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) =>
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          }),
        { threshold: 0.12 }
      );

      revealEls.forEach((el) => {
        el.dataset.stInit = '1';
        io.observe(el);
      });
    } else {
      revealEls.forEach((el) => el.classList.add('is-visible'));
    }

    // -----------------------------
    // Product image flip
    // -----------------------------
    root.querySelectorAll('.st-flip:not([data-st-init])').forEach((el) => {
      el.dataset.stInit = '1';

      if (!el.querySelector('.st-flip__face--back')) return;

      const toggle = () => {
        el.classList.toggle('is-flipped');
      };

      const canHover = window.matchMedia(
        '(hover: hover) and (pointer: fine)'
      ).matches;

      if (canHover) {
        el.addEventListener('mouseenter', () => {
          el.classList.add('is-flipped');
        });

        el.addEventListener('mouseleave', () => {
          el.classList.remove('is-flipped');
        });
      } else {
        el.addEventListener('click', toggle);
      }

      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });

    // // -----------------------------
    // // Replay video
    // // -----------------------------
    // root.querySelectorAll('[data-st-replay]:not([data-st-init])').forEach((btn) => {
    //   btn.dataset.stInit = '1';

    //   btn.addEventListener('click', () => {
    //     const video = btn
    //       .closest('.st-feature__media')
    //       ?.querySelector('video');

    //     if (video) {
    //       video.currentTime = 0;
    //       video.play();
    //     }
    //   });
    // });

// Replay video
root.querySelectorAll('[data-st-replay]:not([data-st-init])').forEach((btn) => {
  btn.dataset.stInit = '1';

  btn.addEventListener('click', () => {
    const video = btn
      .closest('.st-feature__media')
      ?.querySelector('video');

    if (video) {
      video.currentTime = 0;
      video.play();
    }
  });
});


// Play only visible videos
root.querySelectorAll('.st-feature__media video:not([data-st-video-init])').forEach((video) => {
  video.dataset.stVideoInit = '1';

  video.pause();

  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const currentVideo = entry.target;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          currentVideo.play().catch(() => {});
        } else {
          currentVideo.pause();
        }
      });
    },
    {
      threshold: [0, 0.5, 1]
    }
  );

  videoObserver.observe(video);
});

    // -----------------------------
    // Art Gallery slider
    // -----------------------------
    root.querySelectorAll('[data-st-gallery]:not([data-st-init])').forEach((gallery) => {
      gallery.dataset.stInit = '1';

      const track = gallery.querySelector('.st-gallery__track');
      const slides = [...gallery.querySelectorAll('.st-gallery__slide')];
      const thumbs = [...gallery.querySelectorAll('.st-gallery__thumb')];

      if (!track || !slides.length) return;

      let index = 0;

      const perView = () => {
        if (window.innerWidth < 750) return 1.16;
        if (window.innerWidth < 990) return 1.5;
        return 2;
      };

      const maxIndex = () => {
        return Math.max(
          0,
          slides.length - Math.floor(perView())
        );
      };

      const update = () => {
        index = Math.max(
          0,
          Math.min(index, maxIndex())
        );

        track.style.transform = `translateX(-${
          index * (100 / perView())
        }%)`;

        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle(
            'is-active',
            i === index
          );
        });
      };

      // Previous loop
      gallery
        .querySelector('[data-st-prev]')
        ?.addEventListener('click', () => {
          if (index <= 0) {
            index = maxIndex();
          } else {
            index--;
          }

          update();
        });

      // Next loop
      gallery
        .querySelector('[data-st-next]')
        ?.addEventListener('click', () => {
          if (index >= maxIndex()) {
            index = 0;
          } else {
            index++;
          }

          update();
        });

      // Thumbnail click
      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => {
          index = Math.min(
            maxIndex(),
            i
          );

          update();
        });
      });

      window.addEventListener(
        'resize',
        update,
        { passive: true }
      );

      update();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    init(document);
  });

  document.addEventListener('shopify:section:load', (e) => {
    init(e.target);
  });
})();



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.st-flip').forEach(function (card) {
    const backFace = card.querySelector('.st-flip__face--back');

    if (!backFace) return;

    const canHover = window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    ).matches;

    if (canHover) {
      card.addEventListener('mouseenter', function () {
        card.classList.add('is-flipped');
      });

      card.addEventListener('mouseleave', function () {
        card.classList.remove('is-flipped');
      });
    } else {
      card.addEventListener('click', function () {
        card.classList.toggle('is-flipped');
      });
    }

    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        card.classList.toggle('is-flipped');
      }
    });
  });
});

